<template>
  <v-app>
    <v-content>
      
      <v-container class="bckcolor" fluid fill-height>
        
        <v-layout align-center justify-center>
          <v-flex xs12 sm12 md6>
            <v-card flat style="padding:0px;border-radius:0px">
              <v-layout row wrap>
                <v-flex xs6 sm6 md6 class="res">
                  <img class="center" src="../../assets/headlogo.png" style="padding-top:130px"/>
                </v-flex>
                <v-flex xs12 sm12 md6 style="background-color:#E31E24;color:white">  
                   <v-form class="login-form">
                     <v-layout row wrap style="margin-top:20px">
                       <v-flex xs12 sm12 md12>
                         <h5 class="txtt" style="text-align:left">LOGIN</h5>
                         <h6 class="txt" style="text-align:left">Welcome back, please login to your account.</h6>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="padding-right:20px;">
                        
                          <v-text-field
                          v-model="UserName"
                          append-icon="person"
                          name="login"
                          label="Username"
                          type="text"
                          ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="padding-right:20px;">
                         <v-text-field
                           v-model="Password"
                           :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                           :type="passwordShow ? 'text' : 'password'"
                           @click:append="passwordShow = !passwordShow"
                           name="password"
                           label="Password"
                         ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="text-align:right">
                          <v-btn
                            depressed
                            color="primary"
                            :loading="loginBtn"
                            class="white--text"
                            @click="login()"
                          >
                            LOGIN
                          </v-btn>
                          
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="margin-bottom:-20px">
                         <h6>Don't have an account ? <span style="color:#e0e0e0" class="click" @click="forgotPassword()">Register Now</span></h6>
                       </v-flex>
                       

                     </v-layout>
                  
                </v-form>
                </v-flex>
              </v-layout>
              
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import config from "../../config.json";
//import vuetifyToast from "vuetify-toast";
export default {
  data: () => ({
    menu: false,
    loading: false,
    dialog: false,
    otpDialog: false,
    loginBtn: false,
    signinBtn: false,
    submitBtn: false,
    drawer: null,
    UserName: null,
    Password: null,
    passwordShow: false,
    role: sessionStorage.roles,

    emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
  }),
  props: {
    source: String
  },

  methods: {
    login() {
      this.loginBtn = true
      let UserName = this.UserName;
      let Password = this.Password;
      this.loading = true;
      this.$store
        .dispatch("login", { UserName, Password })
        .then(resp => {

           if(resp.data.roles == 'Administrator') {
             this.$router.push("/_");
             this.loading = false;
           }
           else {
             this.$router.push("/homep");
             this.loading = false;
           }
          })
        .catch(err => {
          this.loading = false;
          this.loginBtn = false;
        });

    },

    forgotPassword() {
      this.$router.push("/registration");
    },
    

  },
  created() {
  }
  

  
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Mulish&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Fugaz+One&display=swap');
</style>
<style lang="css" scoped>
.hdr {
 font-family: 'Fugaz One', cursive;
 font-size: 50px;
 color: #e0e0e0;
}
.hdr1 {
 font-family: 'Fugaz One', cursive;
 color: #e0e0e0;
}
.txt {
 font-family: 'Mulish', sans-serif;
}
.txtt {
 font-family: 'Sora', sans-serif;
}
.lftsid {
  background-color: black !important;
  background-size: cover;
  box-shadow: none !important;
  border-radius: 0px !important;
  height: 350px;
}
.login-form {
  padding: 40px;
}
.bckcolor {
    position: relative;
    background-color: #ffffff;
    background-image: linear-gradient( 36deg, #fff 0%, #d7e1ec 74%);
    box-shadow: inset 0 2px 5px 0px rgb(0 0 0 / 39%);
}
.cursr {
  cursor: pointer;
}
.v-btn {
  margin-left: 0px;
}
.txt_dec:hover {
    text-decoration: underline !important;
}
.click:hover {
  text-decoration: underline !important;
  cursor: pointer;
}
.loginPage {
  background-size:cover
}
.call-button-container {
  margin: auto;
  width: 233px;
  height: 74px;
  vertical-align: middle;
  padding: 10px;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
</style>
